module.exports = __webpack_public_path__ + "static/media/1.04403f22.jpeg";